import styled from "styled-components";

export const Container = styled.div`
  padding: 1rem 0;

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
  }

  .active-chip {
    background-color: #4caf50;
    color: white;
    font-weight: bold;
  }
`;
